import { render, staticRenderFns } from "./FilterText.vue?vue&type=template&id=5b908b0f&"
import script from "./FilterText.vue?vue&type=script&lang=js&"
export * from "./FilterText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports